'use strict';
var parent = require('../../stable/regexp');
require('../../modules/esnext.regexp.escape');

module.exports = parent;
